export { InfoContent } from './InfoContent';
